import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Also store the token in a non-httpOnly cookie so the backend can authenticate
// direct GET requests (e.g. <iframe src="/api/.../case-study.pdf">) without us
// needing to build blob URLs (which some browser extensions block — see
// ERR_BLOCKED_BY_CLIENT). Backend already reads `access_token` from cookies.
function setAuthCookie(token) {
  if (typeof document === "undefined") return;
  const isHttps = typeof window !== "undefined" && window.location.protocol === "https:";
  if (token) {
    const maxAge = 7 * 24 * 60 * 60; // 7 days
    document.cookie = `access_token=${encodeURIComponent(token)}; path=/; max-age=${maxAge}; SameSite=Lax${isHttps ? "; Secure" : ""}`;
  } else {
    document.cookie = `access_token=; path=/; max-age=0; SameSite=Lax${isHttps ? "; Secure" : ""}`;
  }
}

export function setToken(token) {
  if (token) {
    localStorage.setItem("rcw_token", token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    setAuthCookie(token);
  } else {
    localStorage.removeItem("rcw_token");
    delete api.defaults.headers.common["Authorization"];
    setAuthCookie(null);
  }
}

const existing = localStorage.getItem("rcw_token");
if (existing) {
  api.defaults.headers.common["Authorization"] = `Bearer ${existing}`;
  setAuthCookie(existing);
}

export function fileUrl(storagePath) {
  if (!storagePath) return "";
  return `${API}/files/${storagePath}`;
}

/** Build a direct URL to an authenticated PDF endpoint. The JWT is appended as
 *  a query param so the link works in iframes, new tabs and cross-origin
 *  setups where cookies are not sent. */
export function pdfUrl(path, extraParams = {}) {
  const params = new URLSearchParams(extraParams);
  const token = localStorage.getItem("rcw_token");
  if (token) params.set("token", token);
  const qs = params.toString();
  return `${API}${path}${qs ? `?${qs}` : ""}`;
}
